<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">参数管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <div style="display:inline-block;" v-if="isbutShow.selectBut">
              <template>
                  <Input v-model="key" placeholder="用户名" style="width: 300px"></Input>
              </template>
              <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
            </div>
            <Button @click="save" type="primary" class="mRight" v-if="isbutShow.addBut">新增</Button>
            <Button @click="update" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="del">删除</Button>
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- 新增/修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="参数名" prop="key">
                  <Input v-model="formValidate.key" placeholder="请输入参数名"/>
              </FormItem>
              <FormItem label="参数值" prop="value">
                  <Input v-model="formValidate.value" placeholder="请输入参数值"/>
              </FormItem>
              <FormItem label="备注" prop="remark">
                  <Input v-model="formValidate.remark"  placeholder="请输入备注" />
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import treeCom from '../../components/tree'

  export default{
    data(){
      return {
       isbutShow:{
        addBut: false,
        delBut: false,
        updateBut: false,
        selectBut: false,
       },
       permissionsLists:[],
        modelName:'新增',
        key:'',
        pagerData:{
           data:[],
           page:{
              //分页数
               // arrPageSize:[10,20,30,40],
               //分页大小
               pagesize:10,
               //总分页数
               pageCount:1,
               //当前页面
               pageCurrent:1,
               //总数
               totalCount:0
           }

        },
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: 'ID',
                // type: 'index',
                key:'id',
                width: 60,
                align: 'center'
            },
            {
                title: '参数名',
                key: 'key',
                width: 240,
                align: 'center'
            },
            {
                title: '参数值',
                key: 'value',
                align: 'center'
            },
            {
                title: '备注',
                width: 180,
                key: 'remark',
                align: 'center'
            }
        ],
        addModel: false,
        selectionRows:{},
        updateId:'',
        formValidate: {
            key:'',
            value:'',
            remark:''
        },
        ruleValidate: {
            key: [
                { required: true, message: '参数名不能为空', trigger: 'blur' }
            ],
            value:[
                { required: true, message: '参数值不能为空', trigger: 'blur' }
            ],
        },
        modal_loading: false,

      }
    },
    mounted:function(){
       // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------

        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    methods: {
        getLists(pageCurrent,pagesize){
            api.parameter.getLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
            }, error => {
            })
        },
        // 得到选择的id
        getSelectIds: function () {
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
            return null;
          }
          var timingIds = [];
          for(var i=0 ;i < this.selectionRows.length; i++){
            timingIds.push(this.selectionRows[i].jobId);
          }
          return timingIds
        },
        // 搜索关键词
        showKeyList(){
            if(this.key == ''){
              this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
            }else{
              // console.log('通过关键词获取列表')
               api.parameter.getLists({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'key':this.key
                }, resp => {
                  // 获取分页展示list
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   this.key = '';
                }, error => {

                })

            }
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.modelName == "修改"){
                    api.parameter.update({
                      key:this.formValidate.key,
                      value:this.formValidate.value,
                      remark:this.formValidate.remark,
                      id: this.updateId,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }
                      
                    }, error => {

                    })
                  }else if(this.modelName == "新增"){
                    api.parameter.save(this.formValidate, resp => {
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }
                      
                    }, error => {

                    })
                  }
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        // 新增 初始化数据
        save:function(){
            this.modelName = '新增';
            this.formValidate = {
              key: '',
              value: '',
              remark: ''
          }
           this.addModel = true;
        },
        // 修改
        update:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          this.updateId = this.selectionRows[0].id
          this.formValidate = {
            key: this.selectionRows[0].key,
            value:this.selectionRows[0].value,
            remark: this.selectionRows[0].remark
          }
          this.addModel = true;
        },
        // 删除/批量删除
        del:function(){
          var timingIds = this.getSelectIds();
          if (timingIds == null){
            this.$Message.error('请选择你要删除的记录!');
            return false;
          }
          api.parameter.delete(timingIds, resp => {
            if (resp.code === 0){
              this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
              this.$Message.success('删除成功!');
              this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
            } else {
              this.$Message.error(resp.msg);
            }
          }, error => {

          })
        },
        getSelection:function(selection){
          // console.log(222)
            console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },
        // 分页 -- 页数改变
        onChange:function(curpage){
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        }
    },
      components: {treeCom}
    }
</script>



// WEBPACK FOOTER //
// parameter.vue?4002b98a